import {recordsReducer, apiReducer} from '@eitje/api'
import componentsReducer from './components'

export default {
	records: recordsReducer,
	api: apiReducer,
	components: componentsReducer,
}
